module.exports = __webpack_public_path__ + "img/huawei.3a855d29.png";